import { createApp } from 'vue';
import FooterMega from '../components/FooterMega.vue';

document.addEventListener('DOMContentLoaded', () => {
  const app = createApp(FooterMega);
  app.mount('#footer-mega');
});
